import VanillaPay from './VanillaPay';
export default VanillaPay;
